import { SA_SELLER_ID } from 'shared/consts'
import { DISPLAYING_DELIVERY_DATES_FOR_OTC_AND_MP } from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import store from 'shared/store'

export default () => {
  const deliveryDatesForOtcAndMarketplaceExperiment = getExperimentOnClient(
    DISPLAYING_DELIVERY_DATES_FOR_OTC_AND_MP
  )
  const cartEntries = store.getState().cart.data.sellerGroups

  const hasRxItems = cartEntries.some(entry =>
    entry.groupEntries?.some(groupItem => groupItem.type !== 'noPrescription')
  )
  const hasErxItems = cartEntries.some(
    entry =>
      Array.isArray(entry.groupEntriesERx) && entry.groupEntriesERx.length > 0
  )
  const hasWholesalerItems = cartEntries.some(entry =>
    entry.groupEntries?.some(groupItem =>
      groupItem.items?.some(product => product?.outOfStockMessage)
    )
  )
  const hasCoolingItems = cartEntries.some(entry =>
    entry.groupEntries?.some(groupItem =>
      groupItem.items?.some(product => product?.coolingRequired)
    )
  )
  const hasSaeOtcItems = cartEntries.some(
    entry =>
      entry.sellerGroupId === SA_SELLER_ID &&
      entry.groupEntries?.some(
        groupItem =>
          groupItem.type === 'noPrescription' &&
          groupItem.items?.some(product => !product?.outOfStockMessage)
      )
  )
  const hasMpOtcItems = cartEntries.some(
    entry => entry.sellerGroupId !== SA_SELLER_ID
  )
  const hasAnyOtcItems = hasSaeOtcItems || hasMpOtcItems

  if (
    !deliveryDatesForOtcAndMarketplaceExperiment.isEnabled ||
    hasRxItems ||
    hasErxItems ||
    hasWholesalerItems ||
    hasCoolingItems ||
    !hasAnyOtcItems
  ) {
    return
  }

  void activateExperiment(DISPLAYING_DELIVERY_DATES_FOR_OTC_AND_MP)

  //events tracking is already done in app/views/components/organisms/Cart/eventsTracking.ts
}
